import { CREDIT_PACKS } from "@/components/create/creditPacks";
import {
  getAccountEmail,
  isPendingAccountConfirmation,
  type AccountStatusUser,
} from "@/lib/auth/accountStatus";
import {
  CREDIT_RESUME_ID_PARAM,
  hasPendingCreditPurchaseAfterAuth,
} from "@/utils/creditAuthIntentPersistence";
import {
  hasPendingQuoteResumeAfterAuth,
  QUOTE_RESUME_ID_PARAM,
} from "@/utils/quoteResumePersistence";

export type PendingInlineConfirmation =
  | { type: "quote"; email: string }
  | { type: "credit"; email: string; credits: number }
  | null;

/** Rebuilds the exact inline confirmation view from its URL-bound capability. */
export function resolvePendingInlineConfirmation(
  user: AccountStatusUser | null | undefined,
  href: string
): PendingInlineConfirmation {
  if (!isPendingAccountConfirmation(user)) return null;
  const email = getAccountEmail(user);
  if (!email) return null;

  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return null;
  }

  const creditIntentId = url.searchParams.get(CREDIT_RESUME_ID_PARAM);
  const requestedCredits = Number(url.searchParams.get("credit_pack"));
  const selectedPack = CREDIT_PACKS.find(
    pack => pack.credits === requestedCredits
  );
  if (
    url.searchParams.get("credit_intent") === "1" &&
    Boolean(creditIntentId) &&
    selectedPack &&
    hasPendingCreditPurchaseAfterAuth(creditIntentId, selectedPack.credits)
  ) {
    return { type: "credit", email, credits: selectedPack.credits };
  }

  const quoteIntentId = url.searchParams.get(QUOTE_RESUME_ID_PARAM);
  if (
    url.searchParams.get("quote_intent") === "1" &&
    Boolean(quoteIntentId) &&
    hasPendingQuoteResumeAfterAuth(quoteIntentId)
  ) {
    return { type: "quote", email };
  }

  return null;
}
